import { useState, useEffect } from 'react';
import { useTranslations } from '../hooks/useTranslations';

const EarningsNotification = () => {
    const { t } = useTranslations();
    const [earnings, setEarnings] = useState([]);
    const [isAnimating, setIsAnimating] = useState(false);


const usernames = [
    "andrew1987",
    "katya_love",
    "maks_sss",
    "gamer_pro",
    "sunny_day",
    "ivan_petrov",
    "alisa1234",
    "crypto_man",
    "musiclover",
    "fast_runner",
    "dmitry_trader",
    "elena_forex",
    "sergey_crypto",
    "anna_stocks",
    "vladimir_bull",
    "maria_bear",
    "alex_trading",
    "nina_invest",
    "pavel_market",
    "olga_portfolio",
    "mikhail_chart",
    "tatyana_trend",
    "artem_signal",
    "yulia_profit",
    "roman_swing",
    "irina_scalp",
    "denis_daytrade",
    "svetlana_long",
    "konstantin_short",
    "ekaterina_risk",
    "andrey_volatility",
    "natalia_momentum",
    "vitaly_support",
    "lyudmila_resistance",
    "stanislav_breakout",
    "galina_consolidation",
    "igor_divergence",
    "vera_oscillator",
    "anatoly_moving_average",
    "ludmila_bollinger",
    "valentin_rsi",
    "tamara_macd",
    "grigory_stochastic",
    "valentina_fibonacci",
    "boris_elliot_wave",
    "nadezhda_gap",
    "arkady_volume",
    "lyubov_liquidity",
    "leonid_spread",
    "zinaida_margin",
    "fedor_leverage",
    "klavdiya_hedge",
    "semyon_arbitrage",
    "agafya_derivative",
    "prokhor_futures",
    "praskovya_options",
    "terenty_etf",
    "pelageya_commodity",
    "kuzma_currency",
    "akulina_metals",
    "karp_energy",
    "fevronya_agriculture",
    "makar_technology",
    "evdokia_healthcare",
    "klim_financial",
    "melanya_consumer",
    "zot_industrial",
    "domna_utilities",
    "korney_telecom",
    "faina_real_estate",
    "luka_materials",
    "uliana_discretionary",
    "potap_staples",
    "evpraksiya_communication",
    "kapiton_energy",
    "alex_gamer",
    "maria_designer",
    "david_artist",
    "elena_writer",
    "sergey_photographer",
    "anna_chef",
    "vladimir_doctor",
    "olga_teacher",
    "mikhail_engineer",
    "tatyana_lawyer",
    "artem_architect",
    "yulia_nurse",
    "roman_scientist",
    "irina_actress",
    "denis_musician",
    "svetlana_dancer",
    "konstantin_painter",
    "ekaterina_poet",
    "andrey_farmer",
    "natalia_baker",
    "vitaly_carpenter",
    "lyudmila_tailor",
    "stanislav_plumber",
    "galina_electrician",
    "igor_mechanic",
    "vera_hairdresser",
    "anatoly_driver",
    "ludmila_pilot",
    "valentin_sailor",
    "tamara_soldier",
    "grigory_police",
    "valentina_firefighter",
    "boris_ambulance",
    "nadezhda_veterinarian",
    "arkady_dentist",
    "lyubov_psychologist",
    "leonid_surgeon",
    "zinaida_radiologist",
    "fedor_cardiologist",
    "klavdiya_neurologist",
    "semyon_orthopedist",
    "agafya_dermatologist",
    "prokhor_ophthalmologist",
    "praskovya_gynecologist",
    "terenty_pediatrician",
    "pelageya_anesthesiologist",
    "kuzma_pathologist",
    "karp_pharmacist",
    "fevronya_nutritionist",
    "makar_physiotherapist",
    "evdokia_occupational_therapist",
    "klim_speech_therapist",
    "melanya_audiologist",
    "zot_optometrist",
    "domna_chiropractor",
    "korney_acupuncturist",
    "faina_homeopath",
    "luka_herbalist",
    "uliana_aromatherapist",
    "potap_reflexologist",
    "evpraksiya_massage_therapist",
    "kapiton_yoga_instructor",
    "alex_personal_trainer",
    "maria_nutrition_coach",
    "david_life_coach",
    "elena_meditation_guide",
    "sergey_mindfulness_expert",
    "anna_stress_management",
    "vladimir_anger_management",
    "olga_cognitive_behavioral",
    "mikhail_psychoanalyst",
    "tatyana_gestalt_therapist",
    "artem_family_therapist",
    "yulia_couples_counselor",
    "roman_child_psychologist",
    "irina_adolescent_specialist",
    "denis_geriatric_psychologist",
    "svetlana_forensic_psychologist",
    "konstantin_clinical_psychologist",
    "ekaterina_educational_psychologist",
    "andrey_industrial_psychologist",
    "natalia_sports_psychologist",
    "vitaly_health_psychologist",
    "lyudmila_social_psychologist",
    "stanislav_developmental_psychologist",
    "galina_cognitive_psychologist",
    "igor_behavioral_psychologist",
    "vera_positive_psychologist",
    "anatoly_transpersonal_psychologist",
    "ludmila_integrative_therapist",
    "valentin_eclectic_therapist",
    "tamara_brief_therapy_specialist",
    "grigory_solution_focused_therapist",
    "valentina_narrative_therapist",
    "boris_emotionally_focused_therapist",
    "nadezhda_acceptance_commitment_therapist",
    "arkady_dialectical_behavior_therapist",
    "lyubov_schema_therapist",
    "leonid_psychodynamic_therapist",
    "zinaida_psychoanalytic_therapist",
    "fedor_jungian_analyst",
    "klavdiya_adlerian_therapist",
    "semyon_reality_therapist",
    "agafya_choice_therapist",
    "prokhor_rational_emotive_therapist",
    "praskovya_cognitive_restructuring_therapist",
    "terenty_behavior_modification_specialist",
    "pelageya_systemic_family_therapist",
    "kuzma_structural_family_therapist",
    "akulina_strategic_family_therapist",
    "karp_bowen_family_therapist",
    "fevronya_experiential_family_therapist",
    "makar_satir_family_therapist",
    "evdokia_whitaker_family_therapist",
    "klim_minuchin_family_therapist",
    "melanya_haley_family_therapist",
    "zot_madanes_family_therapist",
    "domna_selvini_family_therapist",
    "korney_boscolo_family_therapist",
    "faina_ceccin_family_therapist",
    "luka_penn_family_therapist",
    "uliana_anderson_family_therapist",
    "alexander_warrior",
    "mikhail_hunter",
    "dmitry_fisherman",
    "sergey_blacksmith",
    "vladimir_warrior",
    "nikolay_archer",
    "artem_swordsman",
    "roman_gladiator",
    "ivan_knight",
    "pavel_soldier",
    "andrey_commander",
    "konstantin_general",
    "anatoly_colonel",
    "vitaly_major",
    "stanislav_captain",
    "igor_lieutenant",
    "leonid_sergeant",
    "fedor_corporal",
    "arkady_private",
    "semyon_recruit",
    "prokhor_veteran",
    "terenty_hero",
    "kuzma_champion",
    "makar_victor",
    "klim_conqueror",
    "zot_defender",
    "korney_protector",
    "potap_guardian",
    "kapiton_sentinel",
    "evpraksiya_watchman",
    "fevronya_sentry",
    "akulina_patrol",
    "karpina_scout",
    "karpinich_spy",
    "andrey_wolf",
    "sergey_power",
    "maksim_hero",
    "pavel_rider",
    "dmitry_shadow",
    "ivan_craft",
    "nikita_game",
    "alexey_pro",
    "egor_fast",
    "anton_drive",
    "roman_steel",
    "igor_code",
    "vadim_rock",
    "ilya_cloud",
    "artem_fire",
    "vlad_storm",
    "stas_dark",
    "slava_sky",
    "timur_rider",
    "bogdan_star",
    "denis_wave",
    "yura_speed",
    "fedor_wolf",
    "gennady_power",
    "kostya_flow",
    "misha_time",
    "leonid_light",
    "stepan_gold",
    "arkady_space",
    "boris_shadow",
    "valentin_drive",
    "rodion_fire",
    "german_rock",
    "oleg_code",
    "nikon_fast",
    "vova_cool",
    "stas_craft",
    "peter_ocean",
    "ruslan_steel",
    "grigory_dark",
    "andrey_play",
    "sergei_magic",
    "yuriy_cloud",
    "alex_shadow",
    "mikhail_drive",
    "roman_speed",
    "timofey_power",
    "gleb_fast",
    "danil_code",
    "konstantin_fire",
    "arsen_wolf",
    "oleg_star",
    "stepan_flow",
    "valera_dark",
    "artur_light",
    "nikolay_game",
    "stefan_space",
    "ilya_wolf",
    "dima_sky",
    "egor_cool",
    "mikhail_rider",
    "denis_shadow",
    "pasha_fast",
    "slava_hero",
    "grisha_flow",
    "bogdan_drive",
    "timur_dark",
    "andrey_light",
    "german_wave",
    "fedor_cloud",
    "ivan_star",
    "kostya_pro",
    "anton_craft",
    "alexey_fire",
    "sergey_steel",
    "vlad_magic",
    "dmitry_space",
    "nikita_fast",
    "ilya_rock",
    "vadim_dark",
    "roman_storm",
    "oleg_power",
    "stepan_time",
    "arkady_cloud",
    "timur_shadow",
    "maksim_drive",
    "artem_light",
    "boris_sky",
    "stas_pro",
    "egor_fire",
    "grigory_fast",
    "vova_space",
    "gennady_star",
    "denis_magic",
    "pavel_cool",
    "alex_wave",
    "nikon_dark",
    "leonid_flow",
    "ilya_speed"
  ];
  
  // Функция выбора случайного ника и маскирования
  const generateUsername = () => {
    const randomIndex = Math.floor(Math.random() * usernames.length);
    const nick = usernames[randomIndex];
    return `@${nick.slice(0, 4)}***`;
  };

    // Генерация случайных сумм с весами (чем больше сумма, тем реже)
    const generateAmount = () => {
        const random = Math.random();
        
        if (random < 0.6) {
            // 60% вероятность - суммы от 5 до 100
            return Math.floor(Math.random() * 96) + 5;
        } else if (random < 0.85) {
            // 25% вероятность - суммы от 100 до 1000
            return Math.floor(Math.random() * 900) + 100;
        } else if (random < 0.95) {
            // 10% вероятность - суммы от 1000 до 10000
            return Math.floor(Math.random() * 9000) + 1000;
        } else {
            // 5% вероятность - суммы от 10000 до 75000
            return Math.floor(Math.random() * 65000) + 10000;
        }
    };

    // Генерация случайных действий
    const generateAction = () => {
        const actions = [
            { text: t('earningsNotification.actions.earned'), type: 'SELL' },
            { text: t('earningsNotification.actions.earned'), type: 'BUY' }
        ];
        return actions[Math.floor(Math.random() * actions.length)];
    };

    // Создание нового заработка
    const createEarning = () => {
        const username = generateUsername();
        const amount = generateAmount();
        const action = generateAction();
        
        return {
            id: Date.now() + Math.random(),
            username,
            amount,
            actionText: action.text,
            actionType: action.type
        };
    };

    // Добавить новый заработок в список (максимум 3)
    const addNewEarning = () => {
        setIsAnimating(true);
        
        // Небольшая задержка для анимации
        setTimeout(() => {
            const newEarning = createEarning();
            setEarnings(prev => {
                const updated = [newEarning, ...prev.slice(0, 2)]; // Новое сверху, оставляем максимум 3
                return updated;
            });
            setIsAnimating(false);
        }, 200);
    };

    useEffect(() => {
        // Сразу создаем 3 уведомления при загрузке (только если массив пустой)
        if (earnings.length === 0) {
            const initialEarnings = [];
            for (let i = 0; i < 3; i++) {
                initialEarnings.push(createEarning());
            }
            setEarnings(initialEarnings);
        }

        // Установить интервал для добавления новых заработков каждые 5 секунд
        const interval = setInterval(() => {
            addNewEarning();
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, [earnings.length]);

    if (earnings.length === 0) {
        return (
            <div className="bg-gray-800/95 backdrop-blur-md md:rounded-2xl px-6 py-4 shadow-xl border border-gray-600/30 md:min-w-[320px] md:max-w-[380px]">
                <div className="text-gray-300 text-sm text-center mb-3 font-semibold">
                    {t('earningsNotification.title')}
                </div>
                <div className="text-gray-500 text-center text-sm py-2 bg-gray-700/20 rounded-lg">
                    Загрузка...
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gray-800/95 mt-4 h-[160px] md:h-auto md:mt-10 backdrop-blur-md rounded-2xl px-2 py-4 shadow-xl border border-gray-600/30">
            {/* Заголовок */}
            <div className="text-gray-300 text-sm md:text-center mb-3 font-semibold">
                {t('earningsNotification.title')}
            </div>
            
            {/* Подзаголовок */}
            {/* <div className="text-gray-400 text-xs text-center mb-4">
                {t('earningsNotification.header')}
            </div>
             */}
            {/* Список заработков */}
            <div className="space-y-2">
                {earnings.map((earning, index) => (
                    <div 
                        key={earning.id} 
                        className={`text-white text-center text-[12px] rounded-lg py-1 px-2 transition-all duration-300 ${
                            index === 0 ? 'bg-green-600/20 border border-green-500/30' : 'bg-gray-700/40'
                        }`}
                    >
                        <span className="text-white font-medium">{earning.username}</span>{' '}
                        <span className="text-white">{earning.actionText}</span>{' '}
                        <span className="text-white font-bold">{earning.amount}$</span>{' '}
                        <span className="text-green-400 font-medium">
                            - {earning.actionType}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EarningsNotification;
